<template>
  <div class="clearfix">
    <a-upload
      list-type="picture-card"
      :file-list="resetFileList"
      :remove="handleRemove"
      @change="handleChange"
      :beforeUpload="beforeUpload"
      :customRequest="doUpload"
      :disabled="disabled"
      @preview="handlePreview"
    >
      <div v-if="resetFileList.length < maxCount">
        <app-icon type="icon-tianjia" />
        <div class="ant-upload-text">点击上传</div>
      </div>
    </a-upload>
    <!-- <div v-if="loading" style="width:104px;height:104px;line-height:104px;text-align:center;border:1px solid #dfdfdf;border-radius:5px">上传中...</div> -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
<script>
import moment from 'moment'
import { webUpload } from '@/service/oss'
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
export default {
  data() {
    return {
      previewImage: null,
      previewVisible: false,
      loading: false,
    }
  },
  props: {
    fileList: {
      type: Array,
    },
    storeAs: {
      type: Function,
      default(file, key = '') {
        const suffix = file.name.match(/\.[^ .]+$/)[0]
        return `${key}/${moment().format('YYYY/MM')}/${new Date().getTime()}${suffix}`
      },
    },
    uploadType: {
      type: String,
      default: 'image',
    },
    maxCount: {
      type: Number,
      default: 500,
    },
    maxFileSize: {
      type: Number,
      default: 50,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  // watch:{
  //   value(val) {
  //     console.log('总会幼稚吧',val)
  //     if (val) {
  //       this.resetFileList()
  //     }
  //   }
  // },
  computed: {
    resetFileList() {
      if (this.fileList && this.fileList.length > 0) {
        return this.fileList
          .map((item, index) => {
            // 后缀获取
            let matched = ''
            console.log('file', item);

            if (item) {
              matched = item.split('?')[0].split('/').pop();
            }
            const fileName = matched ? matched : 'image.png'
            const fileItem = {
              uid: `-${index}`,
              name: fileName,
              status: 'done',
              url: item,
              response: {
                url: item,
              },
            }
            return fileItem
          })
          .sort()
      }
      return []
    },
  },
  mounted() {},
  methods: {
    handleRemove(file) {
      const index = this.resetFileList.indexOf(file)
      this.$emit('onremove', index)
    },
    handleCancel() {
      this.previewVisible = false
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },

    handleChange({ fileList }) {
      // const srcList = fileList
      // .filter(item => item.status === 'done' && item.response.url)
      // .map(item => {
      //   return item.response.url
      // })
      // if (srcList.length) {
      //   console.log('2222', srcList)
      //   // this.$emit('onchange', srcList)
      // }
    },
    beforeUpload(file) {
      const { uploadType, maxFileSize } = this
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
      if (uploadType.includes(',')) {
        const uploadTypes = this.uploadType.split(',')
        if (uploadTypes.includes('image')) {
          if (!isImage) {
            this.$message.error('请上传png、jpg格式图片文件或mp4格式视频文件!')
            return false
          }
        }
      }
      if (uploadType === 'image') {
        if (!isImage) {
          this.$message.error('请上传png、jpg格式图片文件!')
          return false
        }
      }
      const isLtSize = file.size / 1024 / 1024 < maxFileSize
      if (!isLtSize) {
        this.$message.error(`上传文件不能大于${maxFileSize}M!`)
        return false
      }
    },
    upLoading() {
      this.loading = false
    },
    doUpload(ev) {
      const { file, onError, onSuccess } = ev
      webUpload(file).then(res => {
        if (res && res.data) {
          onSuccess()
          this.$emit('onchange', res.data)
        } else {
          onError(res)
        }
      })
    },
  },
}
</script>
<style>
.clearfix {
}
/* you can make up upload button and sample style by using stylesheets */
/* .ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
} */
</style>
